"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CulturesInTheirLanguages = exports.CultureCodes = exports.Cultures = void 0;
exports.Cultures = {
    EnglishCanada: "en-CA",
    EnglishUnitedKingdom: "en-GB",
    EnglishUnitedStates: "en-US",
    EnglishAustralia: "en-AU",
    FrenchCanada: "fr-CA",
    FrenchFrance: "fr-FR",
    SpanishSpain: "es-ES",
    GermanGermany: "de-DE",
    DutchNetherlands: "nl-NL",
    ItalianItaly: "it-IT",
    PortuguesePortugal: "pt-PT",
    SpanishMexico: "es-MX",
    SpanishLatinAmerica: "es-419",
    StretchEnglish: "en-ZW",
    MicroCodeEnglish: "en-ZA",
    CroatianCroatian: "hr-HR",
    CzechCzech: "cs-CZ",
    DanishDanish: "da-DK",
    FinnishFinish: "fi-FI",
    HungarianHungarian: "hu-HU",
    NorwegianBokmal: "nb-NO",
    NorwegianNynorsk: "nn-NO",
    PolishPolish: "pl-PL",
    SlovakSlovak: "sk-SK",
    SwedishSweden: "sv-SE",
    SimplifiedChinese: "zh-CN",
    JapaneseJapan: "ja-JP"
};
exports.CultureCodes = Object.values(exports.Cultures);
var CulturesInTheirLanguages;
(function (CulturesInTheirLanguages) {
    CulturesInTheirLanguages["EnglishCanada"] = "English (Canada)";
    CulturesInTheirLanguages["EnglishUnitedKingdom"] = "English (UK)";
    CulturesInTheirLanguages["EnglishUnitedStates"] = "English (US)";
    CulturesInTheirLanguages["EnglishAustralia"] = "English (AU)";
    CulturesInTheirLanguages["FrenchCanada"] = "Fran\u00E7ais (Canada)";
    CulturesInTheirLanguages["FrenchFrance"] = "Fran\u00E7ais (France)";
    CulturesInTheirLanguages["SpanishSpain"] = "Espa\u00F1ol (Espa\u00F1a)";
    CulturesInTheirLanguages["GermanGermany"] = "Deutsch (Deutschland)";
    CulturesInTheirLanguages["DutchNetherlands"] = "Nederlands (Nederland)";
    CulturesInTheirLanguages["ItalianItaly"] = "Italiano (Italia)";
    CulturesInTheirLanguages["PortuguesePortugal"] = "Portugu\u00EAs (Portugal)";
    CulturesInTheirLanguages["SpanishMexico"] = "Espa\u00F1ol (M\u00E9xico)";
    CulturesInTheirLanguages["SpanishLatinAmerica"] = "Espa\u00F1ol (Am\u00E9rica Latina)";
    CulturesInTheirLanguages["StretchEnglish"] = "Stretched English";
    CulturesInTheirLanguages["MicroCodeEnglish"] = "MicroCoded English";
    CulturesInTheirLanguages["CroatianCroatian"] = "Hrvatski (Hrvatska)";
    CulturesInTheirLanguages["CzechCzech"] = "\u010Ce\u0161tina (\u010Cesk\u00E1 republika)";
    CulturesInTheirLanguages["DanishDanish"] = "Dansk (Danmark)";
    CulturesInTheirLanguages["FinnishFinish"] = "Suomi (Suomi)";
    CulturesInTheirLanguages["HungarianHungarian"] = "Magyar (Magyarorsz\u00E1g)";
    CulturesInTheirLanguages["NorwegianBokmal"] = "Norsk Bokm\u00E5l (Norge)";
    CulturesInTheirLanguages["NorwegianNynorsk"] = "Norsk Nynorsk (Norge)";
    CulturesInTheirLanguages["PolishPolish"] = "Polski (Polska)";
    CulturesInTheirLanguages["SlovakSlovak"] = "Sloven\u010Dina (Slovensko)";
    CulturesInTheirLanguages["SwedishSweden"] = "Svenska (Sverige)";
    CulturesInTheirLanguages["SimplifiedChinese"] = "\u7B80\u4F53\u4E2D\u6587 (\u4E2D\u56FD)";
    CulturesInTheirLanguages["JapaneseJapan"] = "\u65E5\u672C\u8A9E (\u65E5\u672C)";
})(CulturesInTheirLanguages = exports.CulturesInTheirLanguages || (exports.CulturesInTheirLanguages = {}));
//# sourceMappingURL=cultures.js.map